/* 路由配置文件 可根据项目需求进行修改 */
/* 路由懒加载配置 */

const index = () => import(/* webpackChunkName: "index" */ '@/views/index')
const select = () => import(/* webpackChunkName: "select" */ '@/views/select')
const exchangeDetails = () => import(/* webpackChunkName: "exchangeDetails" */ '@/views/exchangeDetails')
const exchange = () => import(/* webpackChunkName: "exchange" */ '@/views/exchange')
const pay = () => import(/* webpackChunkName: "pay" */ '@/views/pay')
const myExchange = () => import(/* webpackChunkName: "myExchange" */ '@/views/myExchange')
const recordList = () => import(/* webpackChunkName: "recordList" */ '@/views/recordList')
const explain = () => import(/* webpackChunkName: "explain" */ '@/views/explain')
const couponCodeDetails = () => import(/* webpackChunkName: "explain" */ '@/views/couponCodeDetails')
const xiCouponCodeDetails = () => import(/* webpackChunkName: "explain" */ '@/views/xiCouponCodeDetails')
const nouseCodeDetails = () => import(/* webpackChunkName: "explain" */ '@/views/nouseCodeDetails')
const orderDetails = () => import(/* webpackChunkName: "explain" */ '@/views/orderDetails')

const newOrderDetails = () => import('@/views/newOrderDetails.vue')
const xiCouponOrderDetails = () => import(/* webpackChunkName: "explain" */ '@/views/xiCouponOrderDetails')
const onlineService = () => import(/* webpackChunkName: "explain" */ '@/views/onlineService')

const newSelect = () => import(/* webpackChunkName: "newSelect" */ '@/views/newSelect.vue')

// 路由配置文件
const routerConfig = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: index,
    meta: {
      title: '权益兑换'
    }
  },
  {
    path: '/select',
    name: 'select',
    component: select,
    meta: {
      title: '选择权益',
      keepAlive: true
    }
  },
  {
    path: '/newSelect',
    name: 'newSelect',
    component: newSelect,
    meta: {
      title: '选择权益',
      keepAlive: true,
      no_ball: true
    }
  },
  {
    path: '/exchangeDetails',
    name: 'exchangeDetails',
    component: exchangeDetails,
    meta: {
      title: '权益详情',
      keepAlive: false
    }
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: exchange,
    meta: {
      title: '确认兑换',
      keepAlive: false
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: pay,
    meta: {
      title: '兑换结果'
    }
  },
  {
    path: '/myExchange',
    name: 'myExchange',
    component: myExchange,
    meta: {
      title: '我的兑换'
    }
  },
  {
    path: '/recordList',
    name: 'recordList',
    component: recordList,
    meta: {
      title: '使用记录',
      keepAlive: true
    }
  },
  {
    path: '/explain',
    name: 'explain',
    component: explain,
    meta: {
      title: '权益说明'
    }
  },
  {
    path: '/couponCodeDetails',
    name: 'couponCodeDetails',
    component: couponCodeDetails,
    meta: {
      title: '券码详情'
    }
  },
  {
    path: '/xiCouponCodeDetails',
    name: 'xiCouponCodeDetails',
    component: xiCouponCodeDetails,
    meta: {
      title: '券码详情'
    }
  },
  {
    path: '/nouseCodeDetails',
    name: 'nouseCodeDetails',
    component: nouseCodeDetails,
    meta: {
      title: '券码详情'
    }
  },
  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: orderDetails,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/newOrderDetails',
    name: 'newOrderDetails',
    component: newOrderDetails,
    meta: {
      title: '订单详情',
      no_ball: true
    }
  },
  {
    path: '/xiCouponOrderDetails',
    name: 'xiCouponOrderDetails',
    component: xiCouponOrderDetails,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/onlineService',
    name: 'onlineService',
    component: onlineService,
    meta: {
      title: '在线客服'
    }
  }
]

export default routerConfig
